import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { useParams, useNavigate } from 'react-router-dom';

//import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap"; 

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl, mediaUrl} from'../Config/Config';
import axios from 'axios';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const withRouter = WrappedComponent => props => {
      const params = useParams();
      const  navigate = useNavigate();
      // etc... other react-router-dom v6 hooks
      
      return (
        <WrappedComponent
        {...props}
        params={params}
        navigate ={navigate}
        // etc...
        />
      );
      };


class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      advisorylist:'',
      domainlist:[],
      confirmDelete:'',
    };
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
      // var qs = require('qs');
      // var admin_id = localStorage.getItem("admin_id");
      // var loggedas = localStorage.getItem("loggedas");
      // var postobject = {
      // activePage: 1,
      // search_all: '',
      // admin_id: admin_id,
      // loggedas: loggedas
      // };  

      // axios.post(apiUrl+"advisorydropdown/list",qs.stringify(postobject)).then(res => {
      //   if(res.data.status === 'success'){
         
      //       this.setState({  advisorylist: res.data.advisorylist, totalRecord: res.data.records_count}, function() {
            
      //         this.advisorylist();
      //       });
  
      //   }
      // }); 

      this.listloadData();
   }
   listloadData(postobject=''){
     var qs = require('qs');
  
     let admin_id = localStorage.getItem("admin_id")
      
       if(postobject!=''){
         var postobject=postobject;
       }else{
         var postobject = {
           activePage: 1,
           search_all: '',
           admin_id: admin_id,
           };  
       }
        axios.post(apiUrl+"advisorydropdown/list",qs.stringify(postobject)).then(res => {            
          if(res.data.status === 'success'){	
            this.setState({  advisorylist: res.data.advisorylist, totalRecord: res.data.records_count}, function() {
              this.advisorylist();
            });
          } else {
            this.setState({  bt_data:[] ,advisorylist: [], totalRecord : 0}, function() {
              this.advisorylist();
          });
          }
        }); 
   
   }
   

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
       loggedas:loggedas
     };
    //  this.props.getadvisorylist(qs.stringify(postobject))
    axios.post(apiUrl+"advisorydropdown/list",qs.stringify(postobject)).then(res => {
      
      if(res.data.status === 'success'){
          this.setState({  advisorylist: res.data.advisorylist, totalRecord: res.data.records_count}, function() {
            this.advisorylist();
          });

      }
    }); 

   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  axios.post(apiUrl+"advisorydropdown/list",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){
        this.setState({  advisorylist: res.data.advisorylist, totalRecord: res.data.records_count}, function() {
          this.advisorylist();
        });
    }else{
      
        this.setState({  advisorylist: '', totalRecord: 0}, function() {
          this.advisorylist();
        });
    
    }
  }); 
} 



deleteConfirm=(confirmstatus,id)=>{
  if(confirmstatus == 'yes'){
    $('.confirm-action-delete').removeClass('show');
    var qs = require('qs');

    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      id :this.state.confirmDelete,
    };
    axios.post(apiUrl+"advisorydropdown/delete",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){ 
        $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
        setTimeout(function() {
          $('.success_message').html('');
          this.listloadData();
        }.bind(this),3000);      
      } else {
        $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
        setTimeout(function() {
          $('.success_message').html('');
        }.bind(this),3000);
      }
    });
  }else{
    $('.confirm-action-delete').removeClass('show');	
  }
}  
deleteadvisory(id){
  this.setState({confirmDelete : id})
  $('.confirm-action-delete-message').html('Are you sure delete the advisory dropdown?');	
  $('.confirm-action-delete').addClass('show');	
 }
activateadvisory(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };

      axios.post(apiUrl+"advisorydropdown/change_status",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
          setTimeout(function() {
            $('.success_message').html('');   
            this.listloadData();          
          }.bind(this),3000);
        } else {
          $('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
          setTimeout(function() {
            $('.success_message').html('');
          }.bind(this),3000);
        }
      }); 
}


advisorylist() {
  let catImg = '';
  let preview = '';
    var advisorylist = this.state.advisorylist;
    if (advisorylist != "undefined" && advisorylist != null) {
      console.log(advisorylist);
    
      if (advisorylist.length > 0) {

        if (Object.keys(advisorylist).length > 0) {
          const helperlistDetails = advisorylist.map(
            (advisorylist, Index) => {
              let sno = Index+1;
              

               if(advisorylist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
             
              return (
                <tr key={advisorylist.id}>
      					<td>{sno}</td>
      					<td>{advisorylist.name}</td>
      					<td>{advisorylist.priority}</td>      					
                <td>{status}</td>
                <td className="actiongroup" >
                    <Link to={{ pathname: '/advisorydropdown-edit/'+advisorylist.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'Active'?<Link onClick={this.activateadvisory.bind(this, advisorylist.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateadvisory.bind(this, advisorylist.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}      
                    <Link onClick={this.deleteadvisory.bind(this,advisorylist.id)} className="" title="Duplicate"><i class="ft-trash-2" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="11" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="11" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {

    const {domainlist,universitynamelist} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="advisorydropdown" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
   
         <div className="car-listing-wrap leaa-admin-head card vi-2">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>Advisory Dropdown</h3>
                </div>
               

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 <div className="add_button">  
                    <a className="" href='/advisorydropdown-add'>Add</a>
                </div>
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row table-avrech">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Name</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th style={{width:"100px"}}>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.advisorylist()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      <div className="confirm-action-delete">
								<p className="confirm-action-delete-message"></p>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.abus_id)} className="btn">Yes</a>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
								<span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
				</div>
    </div>
    );
  }
}
export default (withRouter(List));